import React from 'react'
import { getProperty } from '../utils'
import MultipleCheckbox from './multiplecheckbox'

/* eslint-disable react/prop-types */

export default function CategorisedMultipleCheckbox(props) {
    // first categorise all the options
    const categoryOptions = {}
    const categoriseBy = props.categoriseBy || 'category'

    for (const item of props.options) {
        const category = getProperty(item, categoriseBy, 'Uncategorised')

        if (! categoryOptions[category]) {
            categoryOptions[category] = []
        }

        categoryOptions[category].push(item)
    }

    // now, get the rendered category
    const categorySections = []

    for (const category in categoryOptions) {
        categorySections.push(
            <div className="type-box" key={ category }>
                <div className="type-box__heading">{ category }</div>
                <div className="type-box__options">
                    <MultipleCheckbox
                        error={ props.error }
                        name={ props.name }
                        options={ categoryOptions[category] }
                        updateValue={ props.updateValue }
                        value={ props.value }
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="additional-crew-positions">
            { categorySections }
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/components/ui/categorised_multiple_checkbox.js